const purple = "#5236AB";

const styles = {
  page: {
    minHeight: "100dvh",
    display: "grid",
    placeItems: "center",
    p: 2,
    background: "linear-gradient(180deg, rgba(82,54,171,0.06) 0%, rgba(82,54,171,0.02) 100%)",
  },
  card: {
    width: "100%",
    maxWidth: 520,
    borderRadius: 0,
    bgcolor: "#fff",
  },
  content: {
    p: { xs: 3, sm: 4 },
    display: "grid",
    justifyItems: "center",
    gap: 2,
    textAlign: "center",
  },
  badge: {
    width: 64,
    height: 64,
    borderRadius: 9999,
    display: "grid",
    placeItems: "center",
    backgroundColor: "#F3F0FF",
    color: purple,
    mb: 1,
  },
  title: { m: 0, fontWeight: 700 },
  subtitle: { m: 0, color: "text.secondary" },
  caption: { color: "text.secondary" },
  actions: {
    p: { xs: 3, sm: 4 },
    pt: 0,
    display: "flex",
    justifyContent: "center",
    gap: 2,
  },
  btnPrimary: {
    bgcolor: purple,
    color: "#fff",
    px: 3,
    "&:hover": { bgcolor: purple, color: "#fff" },
  },
};

export default styles;
export { purple };
